import { useEffect } from 'react';

import { TaxonomyType } from '@revelio/data-access';

import { useActivityTaxonomyConfig } from '../../../../../shared/selection-lists/hooks/useActivityTaxonomyConfig';
import { useCurrentReferenceTaxonomyVersion } from '../../../../../shared/selection-lists/hooks/useReferenceTaxonomyVersions';
import { useCurrentRoleTaxonomyVersion } from '../../../../../shared/selection-lists/hooks/useRoleTaxonomyAdapter';
import { useFilterContext } from '../../../filters/contexts/FilterProvider';
import { createNonPrimaryParameterFilterMap } from '../../../filters/utils/createNonPrimaryParameterFilterMap';
import type { ReportParameterConfig } from '../../PageConfigProvider/page-reducer';

export const useAddParameterFilterGroup = ({
  parameters,
}: {
  parameters: ReportParameterConfig[];
}) => {
  const { filterState, dispatch: filterDispatch } = useFilterContext();
  const { version: roleTaxonomyVersion } = useCurrentRoleTaxonomyVersion();
  const { version: skillTaxonomyVersion } = useCurrentReferenceTaxonomyVersion({
    taxonomyType: TaxonomyType.Skill,
  });
  const activityTaxonomyConfig = useActivityTaxonomyConfig();

  useEffect(() => {
    // if there are multiple additional parameters, set them as additional filterMaps
    const additionalParameterIds = parameters
      .slice(1)
      .map((p) => p.parameterId);
    if (additionalParameterIds.length < 1) return;

    const groupMap = filterState?.groupMap;
    const groupMapKeys = Array.from(groupMap?.keys() ?? []);
    const parametersNotInGroupMap = additionalParameterIds.filter(
      (id) => !groupMapKeys.includes(id)
    );
    if (parametersNotInGroupMap.length < 1) return;

    parametersNotInGroupMap.forEach((id) => {
      const newFilterMap = createNonPrimaryParameterFilterMap({
        roleTaxonomyVersion,
        skillTaxonomyVersion,
        ...activityTaxonomyConfig,
      });
      filterDispatch({
        type: 'ADD_NEW_FILTER_GROUP',
        payload: { newFilterKey: id, newFilterMap },
      });
    });
  }, [
    filterState?.groupMap,
    parameters,
    roleTaxonomyVersion,
    skillTaxonomyVersion,
    activityTaxonomyConfig,
    filterDispatch,
  ]);
};
